<template>
  <div class="container">
    <div class="bar" ref="bar" :class="{'is-fixed': isOutOfPort}">
      <div class="bar-item"
      :class="[index === activeIndex ? 'is-active' : '', `bar-item-${index}`]"
      v-for="(item ,index) in bars" :key="index"
      @click="barHandler(item.id, index)">
        {{ item.name }}
      </div>

      <!-- <img :src="qcode" alt=""> -->

      <div
        class="qrcode-item"
        :class="qrcodeListHoverMemory[item.id] ? 'is-active': ''"
        v-for="item in qrcodeList"
        :key="item.id"
        @mouseenter="mouseoverHandler(item.id)"
        @mouseleave="mouseoutHandler(item.id)"
      >
        <img
          class="img"
          :src="qrcodeListHoverMemory[item.id] ? item.hoverImg : item.img"
        >
        <p>{{ item.name }}</p>

        <div class="qrcode">
          <img :src="item.qrcode" v-if="qrcodeListHoverMemory[item.id]">
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import VueBus from '@/utils/vueBus'
import { mapState } from 'vuex'

export default {
  data () {
    return {
      activeIndex: 0,
      isOutOfPort: false,
      itemScrollTopInfo: [],
      qrcodeListHoverMemory: {}
      // isOpen: false
    }
  },
  props: [
    'bars',
    'qrcodeList'
  ],
  computed: {
    ...mapState(['isEnLang']),

    // qcode () {
    //   return this.isEnLang ? require('../../assets/img/en/qrcode.png') : require('../../assets/img/qrcode.png')
    // }
  },
  created () {
  },
  mounted () {
    // 父元素的高度
    const barEle = document.querySelector('.bar')
    const barHeight = barEle.offsetHeight
    // 每个 item 的高度
    document.querySelectorAll('.bar-item').forEach(ele => {
      this.itemScrollTopInfo.push(ele.offsetTop + ele.offsetHeight / 2 - barHeight / 2)
    })

    VueBus.$on('setTargetIndex', this.scrollToTargetBranchHandler)

    if (this.$refs.bar && this.$refs.bar.getBoundingClientRect().left < 0) this.isOutOfPort = true
  },
  methods: {
    /**
     * 滚动到对应的 分会
     * @param {index} Number 对应 bar 的 索引值
     */
    barHandler (id, index) {
      this.activeIndex = index

      VueBus.$emit('scrollToTargetBranch', id)

      document.querySelector('.bar').scrollTop = this.itemScrollTopInfo[index]
      // this.$scrollTo(`.bar-item-${index}`, 100, { container: '.bar', offset: -document.querySelector('.bar').offsetHeight / 2 + document.querySelector('.bar-item').offsetHeight / 2 })
    },
    // mouseOverHandler ($event) {
    //   console.log($event)
    // },
    scrollToTargetBranchHandler (index) {
      this.activeIndex = index

      if (document.querySelector('.bar')) document.querySelector('.bar').scrollTop = this.itemScrollTopInfo[index]
      // this.$scrollTo(`.bar-item-${index}`, 100, { container: '.bar', offset: -document.querySelector('.bar').offsetHeight / 2 + document.querySelector('.bar-item').offsetHeight / 2 })
    },

    mouseoverHandler (id) {
      this.$set(this.qrcodeListHoverMemory, id, true)
    },

    mouseoutHandler (id) {
      this.$set(this.qrcodeListHoverMemory, id, false)
    }
  },
  beforeDestroy () {
    VueBus.$off('setTargetIndex', this.scrollToTargetBranchHandler)
  }
}
</script>

<style lang="scss" scoped>

.container {
  position: fixed; left: 0px; top: 15vh;
  width: 110px;
  background: #FFFFFF;
  transition: all 0.3s linear;
  z-index: 100;
  box-shadow: 1px 1px 8px 0px #E9E9E9;
  border-radius: 6px;

  &.is-open {
    left: 10px;
  }

  @media screen and (min-width: 1600px) {
    left: 50%;
    transform: translateX(calc(-680px - 100%))
  }

  @media screen and (max-width: 1470px) {
    display: none;
  }
}
.bar {
  padding: 10px 10px 0;
  // max-height: 50vh;
  // overflow-y: scroll;
  z-index: 999;
  cursor: pointer;
  transition: all 0.3s linear;
  scroll-behavior: smooth;
  color: #818991;
  text-align: center;

  // 去掉滚动条 start
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
  // 去掉滚动条 end

  .bar-item {
    height: 32px;
    font-size: 12px;
    font-weight: 400;
    color: #818991;
    line-height: 32px;
    text-align: center;
    // padding: 2px 0;
    // margin: 6px 0;
    @extend %transition;

    @include enlayoutInner {
      font-size: 14px;
    }

    &:hover {
      color: #000000;
    }
  }

  .bar-item-6 {
    margin-bottom: 20px;
  }

  .is-active {
    color: #000000;
    font-weight: 600;
  }

  .qrcode-item {
    position: relative;
    width: 56px;
    margin: 0 auto;
    padding-bottom: 20px;
    // border-top: 1px solid rgba(#828A92, 0.4);
    text-align: center;
    .img {
      width: 22px;
      margin: 0 auto;
    }
    p {
      margin: 6px 0 0;
      font-size: 12px;
      line-height: 18px;
    }

    .qrcode {
      // position: absolute; top: calc(50% + 10px); left: calc(100% + 8px);
      // width: 161px; height: 106px;
      // background: url(https://static001.geekbang.org/resource/image/08/e2/081b8eebbbb317cc394eef246acc92e2.png) center / contain no-repeat;
      // transform: translateY(-50%);
      img {
        position: absolute; left: calc(50% + 130px); top: -15%; transform: translateX(-50%) translateY(-50%);
        width: 180px; height: 220px;
      }
    }
  }

}

</style>
